'use client';

import { Button } from '@heroui/button';
import { Spacer } from '@heroui/spacer';
import { useEffect, useRef, useState } from 'react';
import localdb from '@/utils/localdb';
import * as api from './api';
import clsx from 'clsx';
import { CloseCircleOutlined } from '@ant-design/icons';
import { h5_path } from '@/constants';
import { Link } from '@heroui/react';

const Key = 'FEEWEE_PRIVACY_AGREE';

export default function Index() {
  const timer = useRef<any>(null);
  const [show, setShow] = useState(false);

  const saveServerTimeDif = async () => {
    const idt = (await localdb.query<number>('i_dt')) || 0;
    if (Math.abs(idt - Date.now()) < 1000 * 60 * 10) {
      return;
    }
    api
      .timeApi()
      .then(ser_time => {
        localdb.save<number>(process.env.NEXT_PUBLIC_CALKEY ?? 'i_dif', ser_time ? ser_time - Date.now() : 0);
        localdb.save<number>('i_dt', Date.now());
      })
      .catch(e => {
        console.debug('i_dif err:', e.message);
      });
  };

  useEffect(() => {
    localdb.initLocalDB();
    localdb.hasKey(Key).then(has => {
      setShow(!has);
    });

    timer.current = setInterval(() => localdb.clearExpireData(), localdb.ONE_SECOND * 5);
    saveServerTimeDif().then(_r => {});

    const bc = new BroadcastChannel(Key);
    bc.onmessage = event => {
      if (typeof event?.data?.agree === 'number') {
        console.info('接收数据:', event.data);
        localdb.save(Key, event.data.agree);
      }
    };

    return () => {
      if (timer.current) {
        clearInterval(timer.current);
      }
    };
  }, []);

  const agree = () => {
    const bc = new BroadcastChannel(Key);
    bc.postMessage({ agree: 1 });
    setShow(false);
  };

  const reject = () => {
    const bc = new BroadcastChannel(Key);
    bc.postMessage({ agree: 0 });
    setShow(false);
  };

  return (
    <div className={clsx('fixed w-full z-10 bottom-0 left-0 pb-4 bg-white/45 shadow-medium invisible backdrop-filter backdrop-blur-md dark:bg-neutral-800/85 ', show && 'visible')}>
      <div className="flex items-center flex-col relative pt-6 max-w-5xl m-auto tracking-[-.01em] text-sm/6 text-left font-[family-name:var(--font-geist-mono)] px-4 sm:flex-row">
        <div className=" absolute top-0 right-0 text-base p-2 cursor-pointer" onClick={() => setShow(false)}>
          <CloseCircleOutlined />
        </div>
        <p className="indent-6 break-all">
          我们在网站上使用 cookie 来为您提供个性化和更好的浏览体验，并分析网站流量。如果您选择禁用部分或全部
          Cookie，我们网站或服务的某些功能可能无法按预期运行。点击右下方的“接受”，即表示您同意我们使用的 Cookie及其用途。
          <Link className="indent-0" size="sm" isExternal showAnchorIcon href={`${h5_path}/privacyprotection.html`}>
            《隐私政策和Cookies政策》
          </Link>
          。
        </p>
        <Spacer x={12} />
        <div className="flex justify-end">
          <Button color="primary" size="sm" radius="full" onPress={agree}>
            接受
          </Button>
          <Spacer x={4} />
          <Button size="sm" radius="full" color="danger" onPress={reject}>
            拒绝
          </Button>
        </div>
      </div>
    </div>
  );
}
